import React, { useEffect, useState } from "react"

interface ManualProgressProps {
    percentage: number
}

export const ManualProgress: React.FC<ManualProgressProps> = ({ percentage }) => {
    return (
        <div className="w-full bg-gray-200 rounded-full h-2">
            <div
                className="bg-cs-500 h-2"
                style={{
                    width: `${percentage}%`,
                }}
            />
        </div>
    )
}

interface AutoProgressProps {
    timeInSeconds?: number
}

export const AutoProgress: React.FC<AutoProgressProps> = ({ timeInSeconds = 5 }) => {
    const [percentage, setPercentage] = useState(0)

    useEffect(() => {
        let timerId: NodeJS.Timeout

        if (percentage < 100) {
            timerId = setInterval(() => {
                setPercentage((prev) => Math.min(prev + ((timeInSeconds * 1000) / 100), 100))
            }, 50)
        }

        return () => {
            if (timerId) clearInterval(timerId)
        }

    }, [percentage, timeInSeconds])

    return (
        <ManualProgress percentage={percentage} />
    )
}
